// Display currencies. Rates are FIXED INDICATIVE mid-rates against USD, used only to
// present totals in the client's home currency — every trade, fee and balance stays
// booked in its real currency and converts at the live rate in the wallet.
export const DISPLAY_CURRENCIES = [
  { code: "USD", symbol: "$", label: "US Dollar", rate: 1 },
  { code: "EUR", symbol: "\u20ac", label: "Euro", rate: 0.92 },
  { code: "GBP", symbol: "\u00a3", label: "Pound Sterling", rate: 0.79 },
  { code: "QAR", symbol: null, label: "Qatari Riyal", rate: 3.64 },
  { code: "SAR", symbol: null, label: "Saudi Riyal", rate: 3.75 },
  { code: "AED", symbol: null, label: "UAE Dirham", rate: 3.67 },
  { code: "KWD", symbol: null, label: "Kuwaiti Dinar", rate: 0.307 },
  { code: "BHD", symbol: null, label: "Bahraini Dinar", rate: 0.377 },
  { code: "OMR", symbol: null, label: "Omani Rial", rate: 0.385 },
  { code: "TRY", symbol: "\u20ba", label: "Turkish Lira", rate: 41.5 },
  { code: "CHF", symbol: null, label: "Swiss Franc", rate: 0.88 },
  { code: "CAD", symbol: null, label: "Canadian Dollar", rate: 1.37 },
  { code: "AUD", symbol: null, label: "Australian Dollar", rate: 1.52 },
  { code: "JPY", symbol: "\u00a5", label: "Japanese Yen", rate: 152 },
  { code: "CNY", symbol: null, label: "Chinese Yuan", rate: 7.15 },
  { code: "SGD", symbol: null, label: "Singapore Dollar", rate: 1.34 },
  { code: "INR", symbol: "\u20b9", label: "Indian Rupee", rate: 86.5 },
  { code: "PKR", symbol: null, label: "Pakistani Rupee", rate: 280 },
  { code: "EGP", symbol: null, label: "Egyptian Pound", rate: 48.5 },
];

// Country -> home currency, mirroring the backend COUNTRY_CCY map.
export const COUNTRY_CCY = {
  "Qatar": "QAR", "Saudi Arabia": "SAR", "United Arab Emirates": "AED", "Kuwait": "KWD",
  "Bahrain": "BHD", "Oman": "OMR", "United States": "USD", "United Kingdom": "GBP",
  "Eurozone": "EUR", "Japan": "JPY", "Switzerland": "CHF", "Canada": "CAD",
  "Australia": "AUD", "India": "INR", "Pakistan": "PKR", "Egypt": "EGP",
  "Turkey": "TRY", "Singapore": "SGD", "China": "CNY",
};

export const ccyMeta = (code) =>
  DISPLAY_CURRENCIES.find((c) => c.code === code) || DISPLAY_CURRENCIES[0];

/** The currency a client's money lives in: their stated base, else their country's. */
export const homeCurrency = (user) => {
  const code = user?.base_currency || COUNTRY_CCY[user?.country] || null;
  return code && DISPLAY_CURRENCIES.some((c) => c.code === code) ? code : "USD";
};

export const fromUsd = (usd, code) => Number(usd || 0) * ccyMeta(code).rate;

export function fmtDisplay(usd, code, digits = 2) {
  const m = ccyMeta(code);
  const n = fromUsd(usd, code).toLocaleString("en-US", {
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  });
  return m.symbol ? `${m.symbol}${n}` : `${n} ${m.code}`;
}

export const rateNote = (code) => {
  const m = ccyMeta(code);
  if (m.code === "USD") return null;
  return `Indicative rate: 1 USD = ${m.rate} ${m.code}`;
};
